import type { TextFieldProps } from '@mui/material'
import { type ChangeEvent, useEffect, useState } from 'react'
import { debouncedDispatch } from '@/redux/dispatchHelpers'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { selectField } from '../../selectors'
import { setValue } from '../../slice'
import type { FieldName } from '../../types'

type TFProps = {
  name: FieldName
} & TextFieldProps

export default function TextArea({ name: _name }: TFProps) {
  const dispatch = useAppDispatch()
  const { field, value } = useAppSelector(selectField(_name))
  const [val, setVal] = useState(value)

  useEffect(
    function updateLocalStateOnStoreChange() {
      setVal(value as string)
    },
    [value],
  )

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setVal(event.target.value)
    debouncedDispatch(
      dispatch,
      setValue({ fieldName: _name, value: event.target.value }),
    )
  }

  return (
    <>
      <label>{field.label}</label>
      <textarea style={style} onChange={handleChange} value={String(val)} />
    </>
  )
}

const style = {
  minWidth: '100%',
  maxWidth: '100%',
  minHeight: '8rem',
  height: '8rem',
  fontFamily: 'Noto Sans, sans-serif',
  fontSize: '16px',
  padding: '0.5rem',
}
